import React, { useEffect, useState } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import PackageCardAlpha from "../packageSidebar/PackageCardAlpha";

const API_TOKEN = process.env.REACT_APP_API_TOKEN;

function RelatedWorkshops({ artforms }) {
  const [workshops, setWorkshops] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const requestedArtforms = String(artforms || "").trim();

    if (!requestedArtforms) {
      setWorkshops([]);
      setLoading(false);
      return () => {
        cancelled = true;
      };
    }

    const fetchRelatedWorkshops = async () => {
      setLoading(true);

      try {
        const apiUrl = `${process.env.REACT_APP_API_FOLDER}list_related_workshops/?artforms=${encodeURIComponent(
          requestedArtforms
        )}`;

        const response = await axios.get(apiUrl, {
          headers: { "X-API-TOKEN": API_TOKEN },
        });

        if (!cancelled) {
          setWorkshops(Array.isArray(response.data) ? response.data.slice(0, 4) : []);
        }
      } catch (error) {
        // Related content is supplementary. Keep the article usable if it fails.
        console.error("Failed to load related workshops:", error);
        if (!cancelled) setWorkshops([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchRelatedWorkshops();

    return () => {
      cancelled = true;
    };
  }, [artforms]);

  if (!loading && workshops.length === 0) return null;

  return (
    <section
      className="fieldnote-related-workshops"
      aria-labelledby="fieldnote-related-workshops-title"
    >
      <h2
        id="fieldnote-related-workshops-title"
        className="fieldnote-related-title"
      >
        Related upcoming workshops
      </h2>

      <div className="row g-4">
        {loading
          ? Array.from({ length: 4 }).map((_, index) => (
              <div className="col-xl-3 col-md-6" key={index}>
                <Skeleton height={360} />
              </div>
            ))
          : workshops.map((workshop) => (
              <div className="col-xl-3 col-md-6 fadeffect" key={`${workshop.ctype}-${workshop.id}`}>
                <PackageCardAlpha workshop={workshop} />
              </div>
            ))}
      </div>
    </section>
  );
}

export default RelatedWorkshops;
